const actions = {
  LOGIN_USER: 'LOGIN_USER',
  LOGIN_USER_SUCCESS: 'LOGIN_USER_SUCCESS',
  LOGIN_USER_FAIL: 'LOGIN_USER_FAIL',
  FILL_USER_REGISTER_FROM_LOGGED_USER: 'FILL_USER_REGISTER_FROM_LOGGED_USER',
  LOGOUT_USER_SUCCESS: 'LOGOUT_USER_SUCCESS',
  VERIFY_LOGGED_USER_SUCCESS: 'VERIFY_LOGGED_USER_SUCCESS',
  UPDATE_AUTH_EMAIL: 'UPDATE_AUTH_EMAIL',
  UPDATE_LOGIN_FIELD: 'UPDATE_LOGIN_FIELD',
  UPDATE_PASSWORD_RECOVERY_FIELD: 'UPDATE_PASSWORD_RECOVERY_FIELD',
  SHOW_REGISTER_PRE_SALE: 'SHOW_REGISTER_PRE_SALE',
  HIDDEN_REGISTER_PRE_SALE: 'HIDDEN_REGISTER_PRE_SALE',
  SHOW_SELECT_COMPREHENSIVENESS: 'SHOW_SELECT_COMPREHENSIVENESS',
  HIDDEN_SELECT_COMPREHENSIVENESS: 'HIDDEN_SELECT_COMPREHENSIVENESS',
  GET_COMERCIAL_PLAN_PAGED: 'GET_COMERCIAL_PLAN_PAGED',
  GET_COMERCIAL_PLAN_PAGED_SUCCESS: 'GET_COMERCIAL_PLAN_PAGED_SUCCESS',
  GET_COMERCIAL_PLAN_PAGED_FAIL: 'GET_COMERCIAL_PLAN_PAGED_FAIL',
  GET_MORE_COMERCIAL_PLAN: 'GET_MORE_COMERCIAL_PLAN',
  GET_MORE_COMERCIAL_PLAN_SUCCESS: 'GET_MORE_COMERCIAL_PLAN_SUCCESS',
  GET_MORE_COMERCIAL_PLAN_FAIL: 'GET_MORE_COMERCIAL_PLAN_FAIL',
  SAVE_NEGOTIATION: 'SAVE_NEGOTIATION',
  SAVE_NEGOTIATION_SUCCESS: 'SAVE_NEGOTIATION_SUCCESS',
  SAVE_NEGOTIATION_FAIL: 'SAVE_NEGOTIATION_FAIL',
  UPDATE_NEGOTIATION_EDIT_FIELD: 'UPDATE_NEGOTIATION_EDIT_FIELD',
  CHECKED_COMPREHENSIVENESS: 'CHECKED_COMPREHENSIVENESS',
  UNCHECKED_COMPREHENSIVENESS: 'UNCHECKED_COMPREHENSIVENESS',
  CHANGED_CLIENT_SEARCH: 'CHANGED_CLIENT_SEARCH',
  UPDATE_NEGOTIATION_CLIENT_OPTIONS: 'UPDATE_NEGOTIATION_CLIENT_OPTIONS',
  UPDATE_NEGOTIATION_CLIENT_OPTIONS_SUCCESS:
    'UPDATE_NEGOTIATION_CLIENT_OPTIONS_SUCCESS',
  UPDATE_NEGOTIATION_CLIENT_OPTIONS_FAIL:
    'UPDATE_NEGOTIATION_CLIENT_OPTIONS_FAIL',
  SELECTED_CLIENT: 'SELECTED_CLIENT',
  REVOKE_SELECT_COMPREHENSIVENESS: 'REVOKE_SELECT_COMPREHENSIVENESS',
  FILL_NATURES: 'FILL_NATURES',
  FILL_NATURES_SUCCESS: 'FILL_NATURES_SUCCESS',
  FILL_NATURES_FAIL: 'FILL_NATURES_FAIL',

  FILL_SALES_TYPE: 'FILL_SALES_TYPE',
  FILL_SALES_TYPE_SUCCESS: 'FILL_SALES_TYPE_SUCCESS',
  FILL_SALES_TYPE_FAIL: 'FILL_SALES_TYPE_FAIL',

  FILL_SALESORIGIN_TYPE: 'FILL_SALESORIGIN_TYPE',
  FILL_SALESORIGIN_TYPE_SUCCESS: 'FILL_SALESORIGIN_TYPE_SUCCESS',
  UPDATE_SALESORIGIN: 'UPDATE_SALESORIGIN',
  FILL_SALESORIGIN_TYPE_FAIL: 'FILL_SALESORIGIN_TYPE_FAIL',

  FILL_PRICE_TABLE: 'FILL_PRICE_TABLE',
  FILL_PRICE_TABLE_SUCCESS: 'FILL_PRICE_TABLE_SUCCESS',
  FILL_PRICE_TABLE_FAIL: 'FILL_PRICE_TABLE_FAIL',
  FILL_PAYMENT_TYPES: 'FILL_PAYMENT_TYPES',
  FILL_PAYMENT_TYPES_SUCCESS: 'FILL_PAYMENT_TYPES_SUCCESS',
  FILL_PAYMENT_TYPES_FAIL: 'FILL_PAYMENT_TYPES_FAIL',
  SEARCH_NEGOTIATIONS: 'SEARCH_NEGOTIATIONS',
  SEARCH_NEGOTIATIONS_SUCCESS: 'SEARCH_NEGOTIATIONS_SUCCESS',
  SEARCH_NEGOTIATIONS_FAIL: 'SEARCH_NEGOTIATIONS_FAIL',
  SEARCH_ALL_NEGOTIATIONS: 'SEARCH_ALL_NEGOTIATIONS',
  SEARCH_ALL_NEGOTIATIONS_SUCCESS: 'SEARCH_ALL_NEGOTIATIONS_SUCCESS',
  SEARCH_ALL_NEGOTIATIONS_FAIL: 'SEARCH_ALL_NEGOTIATIONS_FAIL',
  UPDATE_INPUT_FILTER: 'UPDATE_INPUT_FILTER',
  FILL_NEGOTIATION_DETAIL: 'FILL_NEGOTIATION_DETAIL',
  FILL_NEGOTIATION_DETAIL_SUCCESS: 'FILL_NEGOTIATION_DETAIL_SUCCESS',
  FILL_NEGOTIATION_DETAIL_FAIL: 'FILL_NEGOTIATION_DETAIL_FAIL',
  REDIRECT_TO_REGISTER_APPORTIONMENT: 'REDIRECT_TO_REGISTER_APPORTIONMENT',
  SAVE_APPORTIOMENT: 'SAVE_APPORTIOMENT',
  UPDATE_APPORTIONMENT_FIELD: 'UPDATE_APPORTIONMENT_FIELD',
  UPDATE_APPORTIONMENT_AMOUNT_FIELD: 'UPDATE_APPORTIONMENT_AMOUNT_FIELD',
  REMOVE_APPORTIOMENT: 'REMOVE_APPORTIOMENT',
  FILL_VEHICLES: 'FILL_VEHICLES',
  FILL_MAINVEHICLES: 'FILL_MAINVEHICLES',
  UPDATE_MAINVEHICLE: 'UPDATE_MAINVEHICLE',
  FILL_VEHICLES_SUCCESS: 'FILL_VEHICLES_SUCCESS',
  FILL_VEHICLES_FAIL: 'FILL_VEHICLES_FAIL',
  UPDATE_REMAINING_VALUE: 'UPDATE_REMAINING_VALUE',
  FILL_COMMERCIAL_PLANS: 'FILL_COMMERCIAL_PLANS',
  FILL_COMMERCIAL_PLANS_SUCCESS: 'FILL_COMMERCIAL_PLANS_SUCCESS',
  FILL_COMMERCIAL_PLANS_FAIL: 'FILL_COMMERCIAL_PLANS_FAIL',
  FILL_EXECUTIVE: 'FILL_EXECUTIVE',
  FILL_EXECUTIVE_SUCCESS: 'FILL_EXECUTIVE_SUCCESS',
  FILL_EXECUTIVE_FAIL: 'FILL_EXECUTIVE_FAIL',
  CLEAR_CLIENT_SEARCH: 'CLEAR_CLIENT_SEARCH',
  FILL_COMPREHENSIVENESS: 'FILL_COMPREHENSIVENESS',
  FILL_COMPREHENSIVENESS_SUCCESS: 'FILL_COMPREHENSIVENESS_SUCCESS',
  FILL_COMPREHENSIVENESS_FAIL: 'FILL_COMPREHENSIVENESS_FAIL',
  SELECTED_AGENCY: 'SELECTED_AGENCY',
  CHANGED_AGENCY_SEARCH: 'CHANGED_AGENCY_SEARCH',
  UPDATE_NEGOTIATION_AGENCY_OPTIONS: 'UPDATE_NEGOTIATION_AGENCY_OPTIONS',
  UPDATE_NEGOTIATION_AGENCY_OPTIONS_SUCCESS:
    'UPDATE_NEGOTIATION_AGENCY_OPTIONS_SUCCESS',
  UPDATE_NEGOTIATION_AGENCY_OPTIONS_FAIL:
    'UPDATE_NEGOTIATION_AGENCY_OPTIONS_FAIL',
  CLEAR_AGENCY_OPTIONS: 'CLEAR_AGENCY_OPTIONS',
  CLEAR_CLIENT_OPTIONS: 'CLEAR_CLIENT_OPTIONS',
  CLEAR_APPORTIONMENT: 'CLEAR_APPORTIONMENT',
  SELECT_VEHICLES_TYPE: 'SELECT_VEHICLES_TYPE',
  CLEAR_NEGOTIATION: 'CLEAR_NEGOTIATION',
  SORT_NEGOTIATION_LIST: 'SORT_NEGOTIATION_LIST',
  SAVE_CLIENT: 'SAVE_CLIENT',
  SAVE_CLIENT_FAIL: 'SAVE_CLIENT_FAIL',
  SAVE_CLIENT_SUCCESS: 'SAVE_CLIENT_SUCCESS',
  CLEAR_COMERCIAL_PLAN: 'CLEAR_COMERCIAL_PLAN',
  CLEAR_DIGITAL: 'CLEAR_DIGITAL',
  CLEAR_OTHERS_VEHICLES: 'CLEAR_OTHERS_VEHICLES',
  FILL_APPORTIOMENT: 'FILL_APPORTIOMENT',
  CLEAR_APPORTIOMENT_FIELDS: 'CLEAR_APPORTIOMENT_FIELDS',
  FILL_UFS: 'FILL_UFS',
  CHANGED_REGION: 'CHANGED_REGION',
  UNCHANGED_REGION: 'UNCHANGED_REGION',
  FILL_REGION: 'FILL_REGION',
  CHECKEDS_UFS: 'CHECKEDS_UFS',
  CHECKEDS_UFS: 'CHECKEDS_UFS',
  CHANGE_SAVE_SHAREPOINT: 'CHANGE_SAVE_SHAREPOINT',
  CHANGE_TEXT_SHAREPOINT: 'CHANGE_TEXT_SHAREPOINT',
  UNCHECKED_NACIONAL: 'UNCHECKED_NACIONAL',
  CHECKED_NACIONAL: 'CHECKED_NACIONAL',
  FILL_TOKEN: 'FILL_TOKEN',
  FILL_TOKEN_SUCCESS: 'FILL_TOKEN_SUCCESS',
  FILL_TOKEN_FAIL: 'FILL_TOKEN_FAIL',
  UPDATE_COMMERCIAL_PLAN_TYPE: 'UPDATE_COMMERCIAL_PLAN_TYPE',
  SHOW_PLANS: 'SHOW_PLANS',
  SHOW_PROJECTS: 'SHOW_PROJECTS',
  GET_STATIONS: 'GET_STATIONS',
  GET_STATIONS_SUCCESS: 'GET_STATIONS_SUCCESS',
  GET_STATIONS_FAIL: 'GET_STATIONS_FAIL',
  GET_PROJECTS: 'GET_PROJECTS',
  GET_PROJECTS_SUCCESS: 'GET_PROJECTS_SUCCESS',
  GET_PROJECTS_FAIL: 'GET_PROJECTS_FAIL',
  GET_COMERCIAL_PLAN_STATION: 'GET_COMERCIAL_PLAN_STATION',
  GET_COMERCIAL_PLAN_STATION_SUCCESS: 'GET_COMERCIAL_PLAN_STATION_SUCCESS',
  GET_COMERCIAL_PLAN_STATION_FAIL: 'GET_COMERCIAL_PLAN_STATION_FAIL',
  UPDATE_SELECTED_STATION: 'UPDATE_SELECTED_STATION',
  GET_PROJECT_STATION: 'GET_PROJECT_STATION',
  GET_PROJECT_STATION_SUCCESS: 'GET_PROJECT_STATION_SUCCESS',
  GET_PROJECT_STATION_FAIL: 'GET_PROJECT_STATION_FAIL',
  UPDATE_SEARCH_PLAN: 'UPDATE_SEARCH_PLAN',
  SEARCH_PLAN: 'SEARCH_PLAN',
  SEARCH_PROJECT: 'SEARCH_PROJECT',
  CLEAR_SEARCH: 'CLEAR_SEARCH',
  ADD_LISTA: 'ADD_LISTA'
};

export default actions;
